import { AttributesSelector, Checkbox, Field } from '@workwhile/ui'
import React, { useMemo } from 'react'
import { useUserPaymentsContextValue } from 'pages/UserPayments/context/UserPaymentsProvider'
import { selectableColumns } from './columns'

export const ColumnsFilter = () => {
  const {
    state: { selectedColumnsFilters },
    actions: { setSelectedColumnsFilters },
  } = useUserPaymentsContextValue()

  const selectedPaymentAttributes = useMemo(() => {
    const selectedColumnsSet = new Set(selectedColumnsFilters)
    const selectedPaymentAttributes = selectableColumns.map((column) => {
      return selectedColumnsSet.has(column.id) ? column.label : undefined
    })

    return selectedPaymentAttributes.filter(
      (item): item is NonNullable<typeof item> => Boolean(item)
    )
  }, [selectedColumnsFilters])

  const selectableColumnsCheckboxes = useMemo(() => {
    return selectableColumns.map((column) => {
      const isSelected = selectedColumnsFilters.includes(column.id)
      return (
        <Field key={column.id}>
          <Checkbox
            value={isSelected}
            onChange={() => {
              setSelectedColumnsFilters((prev) => {
                if (prev.includes(column.id)) {
                  return prev.filter((c) => c !== column.id)
                }
                return [...prev, column.id]
              })
            }}
          >
            <span>{column.label}</span>
          </Checkbox>
        </Field>
      )
    })
  }, [selectedColumnsFilters, setSelectedColumnsFilters])

  return (
    <AttributesSelector
      label="Columns"
      rootGroupTitle="Toggle Columns"
      selectedAttributes={selectedPaymentAttributes}
      onClearAll={() => {
        setSelectedColumnsFilters([])
      }}
      selectedAttributeLimit={0}
      groups={[
        <AttributesSelector.Group
          key="payment-columns"
          title="Payment Columns"
          numberOfSelectedAttributes={selectedPaymentAttributes.length}
        >
          {selectableColumnsCheckboxes}
        </AttributesSelector.Group>,
      ]}
    />
  )
}
